/**
 * Landing Collection — JS
 * FAQ accordion only. Tag filtering is handled by custom.js.liquid
 * via generic [data-filter] / [data-filters] attributes.
 */
(function () {
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-landing-faq] li');
    if (!item) return;

    var list = item.closest('[data-landing-faq]');
    var items = list.querySelectorAll('li');
    var wasOpen = item.classList.contains('open');

    items.forEach(function (li) {
      li.classList.remove('open');
    });

    if (!wasOpen) {
      item.classList.add('open');
    }
  });
})();
